import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { TransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import { Link } from 'react-router-dom';

import connect from '../store/connect';
import { Heading } from '../styles/Heading';
import CartItem from './CartItem';
import { color, size } from '../styles/helpers/variables';
import { toCurrency } from '../util/toCurrency';
import { Button } from '../styles/Button';
import { addCartItem, removeCartItem, deleteCartRow } from '../actions/actionCreators';
import { MagicGetaway } from '../styles/helpers/animations';
import { CART_ADD_URL, CART_REMOVE_URL, CART_DELETE_URL } from '../constants/endpoints';
import { analyticsCheckoutEvent } from '../util/analyticEvents';

class Cart extends Component {
  constructor(props) {
    super(props);
    this.addCartItem = this.addCartItem.bind(this);
    this.removeCartItem = this.removeCartItem.bind(this);
    this.deleteCartRow = this.deleteCartRow.bind(this);
  }

  componentDidMount() {
    if (this.props.location.pathname !== '/kassa') {
      analyticsCheckoutEvent('checkoutStep1', 1, this.props.cart.get('cart', List()));
    }
  }
  addCartItem(productId, productOptions, quantity = 1) {
    const productOptionsArray = productOptions.reduce((memory, option) => [...memory, option.get('id')], []);
    this.props.addCartItem({
      endpointUrl: CART_ADD_URL,
      body: { id: productId, Quantity: quantity, Options: productOptionsArray }
    });
  }

  removeCartItem(cartRow, quantity = 1) {
    const rowId = cartRow.get('orderRowId');

    this.props.removeCartItem(
      { endpointUrl: CART_REMOVE_URL, body: { RowSystemId: rowId, Quantity: quantity } },
      cartRow
    );
  }

  deleteCartRow(cartRow) {
    const rowId = cartRow.get('orderRowId');
    this.props.deleteCartRow({ endpointUrl: CART_DELETE_URL, body: { RowSystemId: rowId } }, cartRow);
  }

  render() {
    const { cart, onCheckoutPage } = this.props;

    // map through cart items
    const cartItems = cart
      .get('cart', Map())
      .sortBy(item => item.getIn(['product', 'id']))
      .map((item, index) => (
        <MagicGetaway numberOfOptions={item.get('options').size} key={item.get('orderRowId')}>
          <CartItem
            index={index}
            cartRow={item}
            modifyDisabled={this.props.onCheckoutPage}
            addCartItem={this.addCartItem}
            removeCartItem={this.removeCartItem}
            deleteCartRow={this.deleteCartRow}
          />
        </MagicGetaway>
      ))
      .toArray();

    return (
      <CartWrapper onCheckoutPage={this.props.onCheckoutPage} onMobile={this.props.onMobile}>
        {!this.props.onCheckoutPage && !this.props.onMobile ? <Heading.p>Varukorg</Heading.p> : false}
        <CartContainer>
          <CartItemsContainer>
            {this.props.viewstate.get('pageWidth') < size.xLarge ? (
              false
            ) : (
              <CartItemsHead>
                <span>Produkt</span>
                <span>Summa</span>
              </CartItemsHead>
            )}
            <TransitionGroup>{cartItems}</TransitionGroup>
          </CartItemsContainer>
          <CartMetaData onCheckoutPage={onCheckoutPage}>
            {cart.get('totalCampaignPrice') ? (
              <CartItemBigText color={color.sale}>
                Rabatt - {toCurrency(cart.get('totalCampaignPrice'))}
              </CartItemBigText>
            ) : (
              false
            )}
            {!Number.isNaN(parseInt(cart.get('deliveryCost'), 10)) ? (
              <CartItemBigText>Frakt {toCurrency(parseInt(cart.get('deliveryCost'), 10))}</CartItemBigText>
            ) : (
              <CartItemBigText>{cart.get('deliveryCost')}</CartItemBigText>
            )}
            <CartItemBigText>Moms {toCurrency(cart.get('vat'))}</CartItemBigText>
            <CartItemTotalKey>Total summa</CartItemTotalKey>
            <CartItemTotalValue>{toCurrency(cart.get('grandTotalPrice'))}</CartItemTotalValue>
            {this.props.onCheckoutPage ? false : <CartButton to="/kassa">Gå till kassa</CartButton>}
          </CartMetaData>
        </CartContainer>
      </CartWrapper>
    );
  }
}

const CartWrapper = styled.div`
  background-color: ${color.lightGrey};
  height: 100%;
  padding: 20px 15px 26px 22px;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${size.xLarge}px) {
    padding: 42px 37px 26px 45px;
  }
`;

const CartItemsHead = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    display: inline-block;
    margin-right: 24px;
    margin-bottom: 7px;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.5px;
    text-align: left;
    color: #a7a7a7;
  }
`;

const CartButton = Button.withComponent(Link).extend`
  background-color: ${color.success};
  border-color: ${color.success};
  width: auto;
  text-decoration: none;
  display: block;
  margin: 0;
  padding: 10px 20px;

  @media screen and (min-width: ${size.xLarge}px) {
    padding: 16px 20px;
    margin-top: 20px;
    width: 100%;
  }
`;

const CartItemsContainer = styled.div`
  margin: 0;

  @media screen and (min-width: ${size.xLarge}px) {
    margin: 20px 0 60px;
    min-height: 116px;
  }
`;

const CartContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media screen and (min-width: ${size.xLarge}px) {
    justify-content: space-between;
    display: block;
    flex: 0;
  }
`;

const CartMetaData = styled.div`
  margin: 20px 0 0;
  min-height: 280px;

  @media screen and (min-width: ${size.xLarge}px) {
    margin: 20px 0;
  }

  ${props =>
    props.onCheckoutPage &&
    css`
      min-height: unset;
    `};
`;

const CartItemBigText = styled.p`
  margin: 0;
  display: block;
  text-align: right;
  color: ${props => (props.color ? props.color : color.black)};
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.8;
  letter-spacing: normal;
`;

const CartItemTotalKey = styled.p`
  display: inline-block;
  width: 50%;
  font-size: 10px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  text-align: left;
  color: #000000;

  @media screen and (min-width: ${size.xLarge}px) {
    font-size: 12px;
  }
`;

const CartItemTotalValue = styled.p`
  display: inline-block;
  width: 50%;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #779182;

  @media screen and (min-width: ${size.xLarge}px) {
    font-size: 18px;
  }
`;

Cart.defaultProps = {
  cart: Map(),
  viewstate: Map(),
  onCheckoutPage: false,
  onMobile: false,
  location: {}
};

Cart.propTypes = {
  addCartItem: PropTypes.func.isRequired,
  removeCartItem: PropTypes.func.isRequired,
  deleteCartRow: PropTypes.func.isRequired,
  location: PropTypes.object,
  cart: PropTypes.instanceOf(Map),
  viewstate: PropTypes.instanceOf(Map),
  onMobile: PropTypes.bool,
  onCheckoutPage: PropTypes.bool
};

export default connect(Cart, { addCartItem, removeCartItem, deleteCartRow }, store => ({
  cart: store.cart,
  viewstate: store.viewstate
}));



// WEBPACK FOOTER //
// ./src/components/Cart.js